import { RootParametersProvider, APP_ROOT_PARAMS } from "./root.parameters.provider";
import { UrlListener, UrlParamToWatch } from "./url.listener";
import { NO_VALUE, ValuesExchangeProvider } from "./values.exchange.provider";
import { Injectable, Inject } from "@angular/core";

// it must be provided in root - in order to capture URL params upon reload of page with F5.
@Injectable({
  providedIn: 'root'
})
export class UrlBasedRootParamsProvider extends RootParametersProvider {

  knownRootParams = new Map<string, UrlParamToWatch>();

  constructor(@Inject(APP_ROOT_PARAMS) rootParams: any,
              private readonly urlListener: UrlListener,
              private readonly valuesExchange: ValuesExchangeProvider) {
    super();
    rootParams.forEach((param) => {
      this.knownRootParams.set(param.name, param);
      this.urlListener.declareUrlParam(param);
      this.urlListener.registerListener(param.name, this._handleValueChange.bind(this, param.name, param.mandatory));
    });
  }

  _handleValueChange(topic, isMandatory, value) {
    if (value === NO_VALUE) {
      this.valuesExchange.notifyListeners(topic, NO_VALUE);
      return;
    }
    if (!value) {
      if (this.urlListener.hasReturnUrl()) {
      }
      else {
        if (isMandatory) {
          const paramSpecs = this.knownRootParams.get(topic);
          const selectedItem = paramSpecs.mandatory? paramSpecs.defaultValue : NO_VALUE;
          this.notifyListeners(topic, selectedItem);
          // don't put anything to values exchange.
          // we shall get back here, once default value is published.
        }
        else {
          // {topic} is optional. If its gone - we dont need to put any optional into URL!
          this.valuesExchange.notifyListeners(topic, value);
        }
      }
    }
    else {
      this.valuesExchange.notifyListeners(topic, value);
    }
  }

  public notifyListenersBeforeRouteChange(topic: string, value:any):any {
    // we can't update URL immediately. Why? A very common pattern - somebody fires a new value
    // for root parameter and triggers navigation to open up related page.
    // Angular is cancelling the URL+query params change navigation (the first one) because of too many
    // rapidly fired navigation calls.
    // Therefore just prepare a queryParam, to be added to navigation call..

    return {
      [topic]: JSON.stringify(value)
    };
  }

  public notifyListeners(topic: string, value: any) {
    // beware! This will trigger a router event!
    this.urlListener.updateUrlParam(topic, value);
  }

  public notifyMultipleListeners(multiple: {}) {
    // beware! This will trigger a router event!
    this.urlListener.updateMultipleUrlParams(multiple);
  }

  public getLastKnownValue(topic: string):any {
    // even if data master is URL, lets do not touch it/assume the value has been properly proliferated into values exchange provider
    return this.valuesExchange.getLastKnownValue(topic);
  }

}
